<div class="panel panel-flat">
  <div class="content-group">

    <div class="tabbable">
      <ul class="nav nav-tabs nav-tabs-highlight">
        <li class="active"><a href="#users-tab" data-toggle="tab"> <i class="icon-users position-left"></i>Users</a>
        </li>
        <li><a href="#access-control-tab" data-toggle="tab"> <i class="icon-shield-notice position-left"></i>Access
            Control</a>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane has-padding active" id="users-tab">

          <div class="row" style="padding-left:30px;">
            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: </span>
              <select name="status" required [(ngModel)]="statusFilter" (ngModelChange)="getUserFilter()"
                class="form-control">
                <option selected disabled>Status</option>
                <option value="">All</option>
                <option value="&status=pending">Pending</option>
                <option value="&status=active">Active</option>
                <option value="&status=locked">Locked</option>
                <option value="&status=inactive">Inactive</option>
                <option value="&status=banned">Banned</option>
                <option value="&status=insecure">Insecure</option>
              </select>
            </div>

            <div class="col-md-2 form-group required">
              <span style="float:left" class="control-label">Filter by: </span>
              <select name="status" required [(ngModel)]="verificationFilter" (ngModelChange)="getUserFilter()"
                class="form-control">
                <option selected disabled>Verification Status</option>
                <option value="">All</option>
                <option value="&verified=1">Verified</option>
                <option value="&verified=0">Unverified</option>
              </select>
            </div>

            <div class="col-md-8 form-group required">
              <div class="heading-elements">
                <div class="btn-group pull-right">
                  <a href="" [routerLink]="['/useradd']" type="button"
                    class="btn btn-icon btn-sm bg-slate-800 btn-rounded">

                    <i class="icon-add position-left"></i> Add User</a>
                  <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                    <i class="icon-printer position-left"></i>Print</a>
                </div>
              </div>
            </div>
          </div>

          <div class="panel-body">
            <table class="table datatable-column-search-inputs">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Registered</th>
                  <!--  <th>Type</th> -->
                  <th>Verified</th>
                  <th>Status</th>
                  <th class="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let user of users | paginate: { id: 'users',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                  <td>
                    <div class="media">
                      <!--  <span class="media-left">
                  <img src="assets/img/userm.png" width="40" height="40" class="img-circle img-md" alt="">
                </span> -->
                      <span class="media-left">
                        <img *ngIf="!user.avatar" src="assets/img/userm.png" width="40" height="40"
                          class="img-circle img-md" alt="">
                        <a href="javascript:void(0)" (click)="setProfileUrl(profile.imageUrl,profile.legalIdUrl)"
                          data-toggle="modal" data-target="#profileImModal">
                          <!-- <img [src]="profile.imageUrl" width="40" height="40" class="img-circle img-md" alt=""> -->
                          <img *ngIf="user.avatar" [src]="baseUrl+'assets/'+user.avatar+'/render'" width="40"
                            height="40" class="img-circle img-md" alt="">

                        </a>
                      </span>
                      <div class="media-left">{{user.username}}
                        <div class="text-muted text-size-small">
                          Latest login: {{user?.last_login | date:'medium'}}
                        </div>
                      </div>
                    </div>
                  </td>
                  <!-- <td>{{user.username}}
              <span class="text-muted display-block text-regular">{{user.client?user.client:''}}</span>
            </td> -->
                  <td>{{user.email}}</td>
                  <td>{{user.phone_number}}</td>
                  <td>{{user.created_at|date:short}}</td>
                  <!-- <td>{{user.type}}</td> -->
                  <td>
                    <span class="label label-block label-primary" *ngIf="user.verified">Verified</span>
                    <span class="label label-block label-warning" *ngIf="!user.verified">Unverified</span>
                    <!-- <li class="checkbox checkbox-switchery switchery-xs"><label><input type="checkbox" class="switchery" checked="user.verified"></label></li> -->
                  </td>
                  <td>
                    <span class="label label-block label-default"
                      *ngIf="user.status === 'Pending' || user.status === 'pending'">{{user.status}}</span>
                    <span class="label label-block label-primary"
                      *ngIf="user.status === 'Active' || user.status === 'active'">{{user.status}}</span>
                    <span class="label label-block label-warning"
                      *ngIf="user.status === 'Locked' || user.status === 'locked'">{{user.status}}</span>
                    <span class="label label-block label-danger"
                      *ngIf="user.status === 'Inactive' || user.status === 'inactive'">{{user.status}}</span>
                    <span class="label label-block label-default"
                      *ngIf="user.status === 'Inactive' || user.status === 'insecure'">{{user.status}}</span>
                    <span class="label label-block label-danger"
                      *ngIf="user.status === 'Inactive' || user.status === 'banned'">{{user.status}}</span>
                  </td>
                  <td class="text-center">
                    <ul class="icons-list">
                      <li class="dropdown">
                        <a href="" class="dropdown-toggle" data-toggle="dropdown">
                          <i class="icon-menu9"></i>
                        </a>

                        <ul class="dropdown-menu dropdown-menu-right">
                          <li>
                            <a href="" [routerLink]="['/useradd']" [queryParams]="{'id':user.id}">
                              <i class="icon-file-pdf"></i>Update</a>
                          </li>
                          <li>
                            <a href="">
                              <i class="icon-file-excel"></i>Delete</a>
                          </li>
                          <li class="divider"></li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="javascript:void(0);">Change Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeStatus(user.id,'pending')">
                                  <i class="icon-shuffle"></i> Pending</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(user.id,'active')">
                                  <i class="icon-shuffle"></i> Active</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(user.id,'locked')">
                                  <i class="icon-shuffle"></i> Locked</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(user.id,'insecure')">
                                  <i class="icon-shuffle"></i> Insecure</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(user.id,'banned')">
                                  <i class="icon-shuffle"></i> Banned</a>
                              </li>
                              <li>
                                <a (click)="changeStatus(user.id,'inactive')">
                                  <i class="icon-shuffle"></i> Inactive</a>
                              </li>
                            </ul>
                          </li>
                          <li class="dropdown-submenu dropdown-submenu-left">
                            <a href="#">Change Verification Status</a>
                            <ul class="dropdown-menu">
                              <li>
                                <a (click)="changeVerificationStatus(user.id,1)">
                                  <i class="icon-shuffle"></i> Verified</a>
                              </li>
                              <li>
                                <a (click)="changeVerificationStatus(user.id,0)">
                                  <i class="icon-shuffle"></i> Unverified</a>
                              </li>
                            </ul>
                          </li>
                          <!-- <li>
                      <a href="javascript:void(0)" data-toggle="modal" data-target="#modal_iconified">
                        <i class="icon-cash"></i> Enroll To Ekub</a>
                    </li> -->
                          <li>
                            <a [routerLink]="['/customeradd']" [queryParams]="{'user':user.id}">
                              <!-- <a [routerLink]="['/customeradd',user.id]"> -->
                              <i class="icon-user"></i> Update Profile
                            </a>
                          </li>
                          <li>
                            <a [routerLink]="['/customeradd']" [queryParams]="{'user':user.id}">
                              <i class="icon-shield-notice"></i> Update Role
                            </a>
                          </li>
                          <li>
                            <a href="javascript:void(0)" (click)="setUser(user)" data-toggle="modal"
                              data-target="#password_change_modal">
                              <i class="icon-reset"></i> Change Password</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr *ngIf="users?.length <=0">
                  <td colspan="6" class="text-center"> <i class="icon-info22">&nbsp;</i>No Users found!</td>
                </tr>
              </tbody>
            </table>

            <!-- <div class="text-center">
        <br>

        <pagination-controls id="useres" previousLabel="Pre" nextLabel="Next" (pageChange)="getNewses()">

        </pagination-controls>

        <br>
      </div> -->

            <div class="row">
              <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
              <div class="text-center">

                <pagination-controls id="users" (pageChange)="pageChanged(currentPage = $event)">
                </pagination-controls>

                <br>
              </div>

            </div>


          </div>

        </div>


        <div class="tab-pane has-padding" id="access-control-tab">




          <div class="row">
            <div class="col-md-6">

              <fieldset>
                <legend class="text-semibold">
                  <i class="icon-user-lock position-left"></i> Roles
                  <div class="pull-right">
                    <a href="" [routerLink]="['/useradd']" type="button"
                      class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                      <i class="icon-add position-left"></i> Add Role</a>
                  </div>

                </legend>

                <table class="table datatable-column-search-inputs">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Permissions Count</th>
                      <th>Permissions</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let role of roles | paginate: { id: 'roles',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                      <td>{{role.name}}</td>
                      <td>{{role?.permissions.data.length}}</td>
                      <td>
                        <span style="padding: 5px;margin:2px;" *ngFor="let permission of role?.permissions.data" class="badge badge-flat border-brown text-brown-600">&nbsp;&nbsp;{{permission?.name}}&nbsp;&nbsp;&nbsp;</span>
                        <span *ngIf="role?.permissions?.data.length <=0" class="text-center"> - </span></td>
                      <td class="text-center">
                        <ul class="icons-list">
                          <li class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                              <i class="icon-menu9"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li>
                                <!--  <a href="" [routerLink]="['/roleadd']" [queryParams]="{'id':role.id}"> -->
                                <a href="javascript:void(0);" (click)="editrole(role)">
                                  <i class="icon-file-pdf"></i>Assign Permissions</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr *ngIf="roles?.length <=0">
                      <td colspan="11" class="text-center"> <i class="icon-info22">&nbsp;</i>No roles defined yet!</td>
                    </tr>
                  </tbody>
                </table>


                <div class="row">
                  <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
                  <div class="text-center">

                    <pagination-controls id="roles" (pageChange)="pageChanged(currentPage = $event)">
                    </pagination-controls>

                    <br>
                  </div>

                </div>

              </fieldset>
            </div>


            <div class="col-md-6">

              <fieldset>
                <legend class="text-semibold">
                  <i class="icon-key position-left"></i> Permissions
                  <div class="pull-right">
                    <a href="" [routerLink]="['/useradd']" type="button"
                      class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
                      <i class="icon-download7 position-left"></i> Export</a>
                  </div>
                </legend>
                <table class="table datatable-column-search-inputs">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Count</th>
                      <th>Remark</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let permission of permissions | paginate: { id: 'permissions',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
                      <td>{{permission.name}}</td>
                      <td>32</td>
                      <td>{{permission?.remark}}</td>
                      <td>{{permission.remark}}</td>
                      <td class="text-center">
                        <ul class="icons-list">
                          <li class="dropdown">
                            <a href="" class="dropdown-toggle" data-toggle="dropdown">
                              <i class="icon-menu9"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-right">
                              <li>
                                <a href="javascript:void(0);" (click)="editPermission(permission)">
                                  <i class="icon-file-pdf"></i>Update</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr *ngIf="permissions?.length <=0">
                      <td colspan="11" class="text-center"> <i class="icon-info22">&nbsp;</i>No defined permission yet!
                      </td>
                    </tr>
                  </tbody>
                </table>


                <div class="row">
                  <!-- <p class="text-left" style="color:#00695C;font-weight:600;padding:10px;">{{val}}</p> -->
                  <div class="text-center">

                    <pagination-controls id="permissions" (pageChange)="pageChanged(currentPage = $event)">
                    </pagination-controls>

                    <br>
                  </div>

                </div>

              </fieldset>

            </div>

          </div>


        </div>






      </div>
    </div>






    <!-- Iconified modal -->
    <div id="modal_iconified" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h5 class="modal-title"><i class="icon-menu7"></i> &nbsp;Modal with icons</h5>
          </div>

          <div class="modal-body">
            <div class="alert alert-info alert-styled-left text-blue-800 content-group">
              <span class="text-semibold">Here we go!</span> Example of an alert inside modal.
              <button type="button" class="close" data-dismiss="alert">×</button>
            </div>

            <h6 class="text-semibold"><i class="icon-law position-left"></i> Sample heading with icon</h6>
            <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget
              quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>

            <hr>

            <p><i class="icon-mention position-left"></i> Aenean lacinia bibendum nulla sed consectetur. Praesent
              commodo
              cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus
              auctor fringilla.</p>
          </div>

          <div class="modal-footer">
            <button class="btn btn-link" data-dismiss="modal"><i class="icon-cross"></i> Close</button>
            <button class="btn btn-primary"><i class="icon-check"></i> Save</button>
          </div>
        </div>
      </div>
    </div>
    <!-- /iconified modal -->

    <!-- Password Change modal -->
    <div id="password_change_modal" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h5 class="modal-title">Reset Password</h5>
          </div>

          <form name="passwordResetForm" [formGroup]="passwordResetForm" novalidate>
            <div class="modal-body">
              <div class="form-group">
                <div class="row">
                  <div class="col-sm-6">
                    <label>User</label>
                    <input type="text" placeholder="User" readonly class="form-control"
                      [(ngModel)]="selectedUser.username" formControlName="user">
                  </div>

                  <div class="col-sm-6">
                    <label>Old Password</label>
                    <input type="text" placeholder="Old Password" class="form-control" formControlName="old_password">
                    <!--  <ng-select [items]="ekubs" placeholder="select ekub" formControlName="ekub" bindValue="id"
                  bindLabel="text" required>
                </ng-select> -->
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <div class="row">

                    <label>&nbsp;</label>
                    <label>New Password:</label>
                    <!-- <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ."></textarea> -->
                    <input type="text" placeholder="New Password" class="form-control" formControlName="new_password">
                  </div>
                </div>
              </div>
              <div class="col-sm-6">

                <div class="form-group">
                  <div class="row">
                    <label>&nbsp;</label>
                    <label>Confirm New Password:</label>
                    <!-- <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ."></textarea> -->
                    <input type="text" placeholder="Confirm New Password" class="form-control"
                      formControlName="confirm_password">
                  </div>
                </div>
              </div>

            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
              <button (click)="changePassword()" data-dismiss="modal" class="btn bg-brown">Change Password</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Password Change modal -->